var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"4","height":"4","viewBox":"0 0 4 4","fill":"none"}},[_c('circle',{attrs:{"cx":"2","cy":"2","r":"2","fill":"#BEBEBE"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }